import { render, staticRenderFns } from "./ExportSdses.vue?vue&type=template&id=3a05614a&scoped=true"
import script from "./ExportSdses.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExportSdses.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ExportSdses.vue?vue&type=style&index=0&id=3a05614a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a05614a",
  null
  
)

export default component.exports